module.exports = __webpack_public_path__ + "media/src/public/fonts/Intro-Regular-2657673173f1f89ae465deee269f36aa.ttf";